import React from "react";

import CrossSvg from "../../assets/icons/cross.svg";
import IconSvg from "../IconSvg";

import { SMALL_SCREEN } from "../../utils/breackpoints";

import useModalAnimated from "../../hooks/useModalAnimated";
import useMediaQuery from "../../hooks/useMediaQuery";

const ModalWithTabs = (props) => {
  const { isInMeetRoom = false } = props;
  const { isAnimated } = useModalAnimated();

  const isPhoneScreen = useMediaQuery(SMALL_SCREEN);

  const getModalWidth = () => {
    if (isPhoneScreen) return "90%";
    else return props.maxWidth;
  };

  return (
    <div
      className={`modal-with-tabs ${isAnimated ? "active" : ""} ${isInMeetRoom ? "is-in-meetroom" : ""}`}
    >
      <div
        className="modal-with-tabs__frame"
        style={{ width: getModalWidth() }}
      >
        <div className="modal-with-tabs__top">
          <div className="modal-with-tabs__header">
            <div className="modal-with-tabs__heading">
              {/* <IconSvg svg={props?.headingSvg} />  */}
              <h2>{props?.headingTitle}</h2>
            </div>
            <div className="icon-frame">
              <IconSvg svg={CrossSvg} onMouseDown={props?.closeModal} />
            </div>
          </div>
          <div className="duo-tab" style={{ height: props.minHeight }}>
            <div className="duo-tab__options">{props?.options}</div>
            <div className="duo-tab__content">{props?.content}</div>
          </div>
        </div>
        <div className="modal-with-tabs__footer">{props?.footerButtons}</div>
      </div>
    </div>
  );
};

export default ModalWithTabs;
